import { assert_string_not_empty, assert_type_boolean, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__user_role } from '../../entity/ENUM__user_role';

export class DTO_RESPONSE__auth_success extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.RESPONSE_AUTH_SUCCESS;

  auth_token!: string;

  user_role!: ENUM__user_role;
  user_id!: string;
  user_full_name!: string;
  user_url_relative_avatar!: string;
  user_email!: string;

  google_email!: string;
  microsoft_email!: string;
  github_email!: string;
  discord_email!: string;
  facebook_email!: string;

  is_password_set!: boolean;

  user_number!: number;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_not_empty(this.auth_token);

    assert_type_enum(this.user_role, ENUM__user_role);
    assert_string_not_empty(this.user_id);
    assert_string_not_empty(this.user_full_name);
    assert_string_not_empty(this.user_email); //todo: assert_string_email

    assert_type_boolean(this.is_password_set);
  }
}
